import { render, staticRenderFns } from "./TransactionDetails.vue?vue&type=template&id=c6b8558a&scoped=true&lang=html&"
import script from "./TransactionDetails.vue?vue&type=script&lang=js&"
export * from "./TransactionDetails.vue?vue&type=script&lang=js&"
import style0 from "./TransactionDetails.vue?vue&type=style&index=0&id=c6b8558a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b8558a",
  null
  
)

export default component.exports